import { baseSplitApi } from './baseApi';

const userAuthPath = '/auth'

export const newLoginTag = 'newLogin'

export const userAuthApi = baseSplitApi.injectEndpoints({
  endpoints: (build) => ({
    userLogout: build.mutation({
      query: (data) => {
        return {
          url: `${userAuthPath}/logout`,
          method: 'POST',
          body: data
        }
      }
    }),
    loginJCRUser: build.mutation({
      query: (body) => {
        return {
          url: `${userAuthPath}/login`,
          method: 'POST',
          body: body
        }
      }
    }),
    verifyJCRUserOTP: build.mutation({
      query: (body) => {
        return {
          url: `${userAuthPath}/verify_otp`,
          method: 'POST',
          body: body
        }
      },
      invalidatesTags: [newLoginTag]
    }),

  }),
  overrideExisting: false,
})

// These hooks gets auto generated based on endpoints
export const {
  
  useUserLoginMutation, useUserLogoutMutation, useResetPasswordEmailMutation, useResetPasswordMutation,
  //ops specific
  useLoginJCRUserMutation, useVerifyJCRUserOTPMutation
} = userAuthApi;